// extracted by mini-css-extract-plugin
export default {"select":"src-constrains-AdvancedFilters-Components-OrderAmount-css-module__select--LiZSL"};